import { useEffect, useRef, useState } from 'react';
import Layout from '../Componets/Layout';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function AddClients() {
  const apiUrl = process.env.REACT_APP_API_URL; // API URL from .env file
  const navigate = useNavigate(); // Hook to navigate programmatically
  const [loaded, setLoaded] = useState(false); // save button  loading  efect deta  hold state
  const location = useLocation(); // Get location state from the URL
  const currentPath = location?.pathname || '';
  const focusInputRef = useRef(null); // Ref for the username input
  // Redirect if role is not SUPER_ADMIN
  useEffect(() => {
    const role = localStorage.getItem('role'); // Retrieve role from localStorage
    if (role !== 'SUPER_ADMIN') {
      // Redirect if role is not SUPER_ADMIN
      navigate('/');
    }
    focus();
    // eslint-disable-next-line
  }, []);

  const focus = () => {
    if (focusInputRef.current) {
      focusInputRef.current.focus();
    }
  };

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    website: '',
    address: '',
    city: '',
    pincode: '',
    contactPerson: '',
    contactNo: '',
    registrationDate: '',
    remarks: '',
    isTwoFactorAuthentication: false, // New field for 2FA switch
    otpVerification: 'Email', // New field for OTP verification option
    storage: '',
    isownAWS: false,
    accessKey: '',
    secretAccessKey: '',
    bucketName: '',
    bucketRegion: '',
    bucketUrl: '',
  });

  // Function to handle form submission
  const handleSubmit = async (e) => {
    setLoaded(true);
    e.preventDefault(); // Prevent default form submission behavior
    const token = localStorage.getItem('token');

    // Clone formData to avoid mutating original state
    let filteredData = { ...formData };

    // Remove AWS fields if isownAWS is false
    if (!filteredData.isownAWS && filteredData.isownAWS == false) {
      delete filteredData.accessKey;
      delete filteredData.secretAccessKey;
      delete filteredData.bucketName;
      delete filteredData.bucketRegion;
      delete filteredData.bucketUrl;
    }

    try {
      const response = await axios.post(`${apiUrl}/api/client`, filteredData, {
        headers: {
          Authorization: `${token}`,
        },
      });
      setLoaded(false);
      focus();
      toast.success('Client added successfully');

      setFormData({
        name: '',
        email: '',
        website: '',
        address: '',
        city: '',
        pincode: '',
        contactPerson: '',
        contactNo: '',
        registrationDate: '',
        remarks: '',
        isTwoFactorAuthentication: false,
        otpVerification: 'Email',
        storage: '',
        isownAWS: false,
        accessKey: '',
        secretAccessKey: '',
        bucketName: '',
        bucketRegion: '',
        bucketUrl: '',
      });

      if (currentPath === '/AddClients') {
        const timeOutDuration = 3000;
        const timeoutId = setTimeout(() => {
          if (window.location.pathname === '/AddClients') {
            navigate('/ViewClient');
          }
        }, timeOutDuration);
        return () => clearTimeout(timeoutId);
      }
    } catch (error) {
      error.response?.status === 401 && navigate('/');
      setLoaded(false);
      console.error(error);
      toast.error(error.response?.data?.message || 'Something went wrong');
    }
  };

  // Function to handle input field changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: name === 'pincode' ? parseInt(value) || '' : value,
    }));
  };

  // Function to handle switch (isTwoFactorAuthentication)
  const handleSwitchChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      isTwoFactorAuthentication: e.target.checked,
    }));
  };

  // Function to handle radio button (otpVerification)
  const handleRadioChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      otpVerification: e.target.value,
    }));
  };
  const handleStorageTypeChange = (e) => {
    const value = e.target.value;

    setFormData((prev) => ({
      ...prev,
      storage: value,
      isownAWS: false,
    }));
  };

  const handleAWSOwnerChange = (e) => {
    const { value } = e.target;
    setFormData((prev) => ({
      ...prev,
      isownAWS: value === 'true', // convert string to boolean
    }));
  };

  return (
    <>
      <Layout ac2="active">
        <main id="main" className="main">
          <div className="pagetitle ">
            <nav>
              <ol className="breadcrumb">
                <li className="breadcrumb-item ">
                  <Link to="/Home">Dashboard</Link>
                </li>
                <li className="breadcrumb-item ">
                  <Link to="/ViewClient">View Clients </Link>
                </li>
                <li className="breadcrumb-item active">Add New Clients</li>
              </ol>
            </nav>
          </div>
          {/* <!-- End Page Title --> */}
          <section className="section col-lg-12 ">
            <div className="row ">
              <div className="">
                <div className="card">
                  <div className="card-body mt-5 mx-4">
                    {/* <!-- General Form Elements --> */}
                    <form onSubmit={handleSubmit}>
                      {/* Details of client */}
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-floating mb-2">
                            <input
                              className="form-control"
                              type="text"
                              name="name"
                              value={formData.name}
                              onChange={handleChange}
                              placeholder="Name"
                              required
                              ref={focusInputRef}
                            />
                            <label className="form-label" htmlFor="txtGrNo">
                              Name <span className="text-danger">*</span>
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Address, City, Pincode */}
                      <div className="row">
                        <div className="col-sm">
                          <div className="form-floating mb-2">
                            <input
                              className="form-control"
                              type="text"
                              name="address"
                              value={formData.address}
                              onChange={handleChange}
                              placeholder="Address"
                              required
                            />
                            <label className="form-label" htmlFor="txtGrNo">
                              Address <span className="text-danger">*</span>
                            </label>
                          </div>
                        </div>
                        <div className="col-sm">
                          <div className="form-floating mb-2">
                            <input
                              className="form-control"
                              type="text"
                              name="city"
                              value={formData.city}
                              onChange={handleChange}
                              placeholder="City"
                              required
                            />
                            <label className="form-label" htmlFor="txtGrNo">
                              City <span className="text-danger">*</span>
                            </label>
                          </div>
                        </div>
                        <div className="col-sm">
                          <div className="form-floating mb-2">
                            <input
                              className="form-control"
                              type="number"
                              name="pincode"
                              value={formData.pincode}
                              onChange={handleChange}
                              placeholder="Pincode"
                              required
                              onWheel={(e) => e.target.blur()}
                            />
                            <label className="form-label" htmlFor="txtGrNo">
                              Pin code <span className="text-danger">*</span>
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Contact Person and Number */}
                      <div className="row">
                        <div className="col">
                          <div className="form-floating mb-2">
                            <input
                              className="form-control"
                              type="text"
                              name="contactPerson"
                              value={formData.contactPerson}
                              onChange={handleChange}
                              placeholder="Contact Person"
                              required
                            />
                            <label className="form-label" htmlFor="txtGrNo">
                              Contact Person{' '}
                              <span className="text-danger">*</span>
                            </label>
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-floating mb-2">
                            <input
                              className="form-control"
                              type="text"
                              name="contactNo"
                              value={formData.contactNo}
                              onChange={handleChange}
                              placeholder="Contact Number"
                              required
                            />
                            <label className="form-label" htmlFor="txtGrNo">
                              Contact Number{' '}
                              <span className="text-danger">*</span>
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Email, Website */}
                      <div className="row">
                        <div className="col">
                          <div className="form-floating mb-2">
                            <input
                              className="form-control"
                              type="email"
                              name="email"
                              value={formData.email}
                              onChange={handleChange}
                              placeholder="Email"
                              required
                            />
                            <label className="form-label" htmlFor="txtGrNo">
                              Email<span className="text-danger">*</span>
                            </label>
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-floating mb-2">
                            <input
                              className="form-control"
                              type="text"
                              name="website"
                              value={formData.website}
                              onChange={handleChange}
                              placeholder="Website"
                            />
                            <label className="form-label" htmlFor="txtGrNo">
                              Website{' '}
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Registration Date, Remarks */}
                      <div className="row">
                        <div className="col">
                          <div className="form-floating mb-2">
                            <input
                              className="form-control"
                              type="date"
                              name="registrationDate"
                              value={formData.registrationDate}
                              onChange={handleChange}
                              placeholder="Registration Date"
                              required
                            />
                            <label className="form-label" htmlFor="txtGrNo">
                              Registration Date{' '}
                              <span className="text-danger">*</span>
                            </label>
                          </div>
                        </div>
                        <div className="col">
                          <div className="form-floating mb-2">
                            <input
                              className="form-control"
                              type="text"
                              name="remarks"
                              value={formData.remarks}
                              onChange={handleChange}
                              placeholder="Remarks"
                            />
                            <label className="form-label" htmlFor="txtGrNo">
                              Remarks
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Storage Type */}
                      <div className="row">
                        <div className="col">
                          <div className="form-floating mb-2">
                            <select
                              className="form-select"
                              name="storage"
                              value={formData.storage}
                              onChange={handleStorageTypeChange}
                              required
                            >
                              <option value="">Select Type of Storage </option>
                              <option value="InternalStorage">Local</option>
                              <option value="Aws">AWS</option>
                            </select>
                            <label htmlFor="storage">
                              Storage Type{' '}
                              <span className="text-danger">*</span>
                            </label>
                          </div>
                        </div>
                      </div>

                      {/* Only show this when AWS is selected */}
                      {formData.storage === 'Aws' && (
                        <div className="row">
                          <div className="col">
                            <div className="form-floating mb-2">
                              <select
                                className="form-select"
                                name="isownAWS"
                                onChange={handleAWSOwnerChange}
                                required
                              >
                                <option value="">Select Type of Aws </option>
                                <option value="false">Printf</option>
                                <option value="true">Client</option>
                              </select>
                              <label htmlFor="isownAWS">
                                AWS Owner <span className="text-danger">*</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      )}
                      {formData.storage === 'Aws' &&
                        formData.isownAWS === true && (
                          <>
                            <div className="row">
                              <div className="col">
                                <div className="form-floating mb-2">
                                  <input
                                    className="form-control"
                                    type="text"
                                    name="accessKey"
                                    value={formData.accessKey}
                                    onChange={handleChange}
                                    placeholder="Access Key"
                                    required
                                  />
                                  <label>
                                    Access Key{' '}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                              </div>
                              <div className="col">
                                <div className="form-floating mb-2">
                                  <input
                                    className="form-control"
                                    type="text"
                                    name="secretAccessKey"
                                    value={formData.secretAccessKey}
                                    onChange={handleChange}
                                    placeholder="Secret Access Key"
                                    required
                                  />
                                  <label>
                                    Secret Access Key{' '}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col">
                                <div className="form-floating mb-2">
                                  <input
                                    className="form-control"
                                    type="text"
                                    name="bucketName"
                                    value={formData.bucketName}
                                    onChange={handleChange}
                                    placeholder="Bucket Name"
                                    required
                                  />
                                  <label>
                                    Bucket Name{' '}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                              </div>
                              <div className="col">
                                <div className="form-floating mb-2">
                                  <input
                                    className="form-control"
                                    type="text"
                                    name="bucketRegion"
                                    value={formData.bucketRegion}
                                    onChange={handleChange}
                                    placeholder="Bucket Region"
                                    required
                                  />
                                  <label>
                                    Bucket Region{' '}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col">
                                <div className="form-floating mb-2">
                                  <input
                                    className="form-control"
                                    type="text"
                                    name="bucketUrl"
                                    value={formData.bucketUrl}
                                    onChange={handleChange}
                                    placeholder="Bucket URL"
                                    required
                                  />
                                  <label>
                                    Bucket URL{' '}
                                    <span className="text-danger">*</span>
                                  </label>
                                </div>
                              </div>
                            </div>
                          </>
                        )}

                      {/* Two-Factor Authentication Switch */}
                      <div className="row ">
                        <div className="d-flex flex-row ">
                          <div className="mt-1 px-2">
                            <label> Two-Factor Authentication:</label>
                          </div>
                          <div className="mx-2">
                            <div className="form-check form-switch  ">
                              <input
                                className="form-check-input border-dark "
                                type="checkbox"
                                id="isTwoFactorAuthentication"
                                checked={formData.isTwoFactorAuthentication}
                                onChange={handleSwitchChange}
                                style={{ height: '24px', width: '55px' }}
                              />
                            </div>
                          </div>
                          <div className="mx-2 mt-1">
                            {formData.isTwoFactorAuthentication && (
                              <div className="d-flex flex-row ">
                                <div className=" px-2">
                                  <label> Method:</label>
                                </div>
                                <div className="mx-2">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id="otpEmail"
                                      name="otpVerification"
                                      value="Email"
                                      checked={
                                        formData.otpVerification === 'Email'
                                      }
                                      onChange={handleRadioChange}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="otpEmail"
                                    >
                                      Email
                                    </label>
                                  </div>
                                </div>
                                <div className="">
                                  <div className="form-check">
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      id="otpSMS"
                                      name="otpVerification"
                                      value="SMS"
                                      checked={
                                        formData.otpVerification === 'SMS'
                                      }
                                      onChange={handleRadioChange}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="otpSMS"
                                    >
                                      SMS
                                    </label>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* Submit Button */}
                      <div className="text-end">
                        <button
                          type="button"
                          className="btn btn-primary px-3"
                          onClick={() => navigate(-1)}
                        >
                          <i className="bi bi-arrow-bar-left"></i>Back
                        </button>
                        <button
                          type="submit"
                          className="btn btn-primary  px-4 mx-2"
                          disabled={loaded}
                        >
                          {loaded ? (
                            <>
                              {' '}
                              <span
                                className="spinner-border spinner-border-sm"
                                role="status"
                                aria-hidden="true"
                              ></span>{' '}
                              Wait...
                            </>
                          ) : (
                            <>Save</>
                          )}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <ToastContainer position="top-center" style={{ width: 'auto' }} />
      </Layout>
    </>
  );
}
